"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WallItemArSessionStatusWorldMappingStatus = exports.WallItemArSessionStatusCameraTrackingPausedReason = exports.WallItemArSessionStatusCameraTrackingStatus = exports.WallItemArSessionStatusToJSON = exports.WallItemArSessionStatusFromJSONTyped = exports.WallItemArSessionStatusFromJSON = void 0;
const runtime_1 = require("../runtime");
function WallItemArSessionStatusFromJSON(json) {
    return WallItemArSessionStatusFromJSONTyped(json, false);
}
exports.WallItemArSessionStatusFromJSON = WallItemArSessionStatusFromJSON;
function WallItemArSessionStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cameraTrackingStatus': !(0, runtime_1.exists)(json, 'camera_tracking_status') ? undefined : json['camera_tracking_status'],
        'cameraTrackingPausedReason': !(0, runtime_1.exists)(json, 'camera_tracking_paused_reason') ? undefined : json['camera_tracking_paused_reason'],
        'worldMappingStatus': !(0, runtime_1.exists)(json, 'world_mapping_status') ? undefined : json['world_mapping_status'],
    };
}
exports.WallItemArSessionStatusFromJSONTyped = WallItemArSessionStatusFromJSONTyped;
function WallItemArSessionStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'camera_tracking_status': value.cameraTrackingStatus,
        'camera_tracking_paused_reason': value.cameraTrackingPausedReason,
        'world_mapping_status': value.worldMappingStatus,
    };
}
exports.WallItemArSessionStatusToJSON = WallItemArSessionStatusToJSON;
/**
* @export
* @enum {string}
*/
var WallItemArSessionStatusCameraTrackingStatus;
(function (WallItemArSessionStatusCameraTrackingStatus) {
    WallItemArSessionStatusCameraTrackingStatus["STOPPED"] = "CAMERA_TRACKING_STATUS_STOPPED";
    WallItemArSessionStatusCameraTrackingStatus["NORMAL"] = "CAMERA_TRACKING_STATUS_NORMAL";
    WallItemArSessionStatusCameraTrackingStatus["PAUSED"] = "CAMERA_TRACKING_STATUS_PAUSED";
})(WallItemArSessionStatusCameraTrackingStatus = exports.WallItemArSessionStatusCameraTrackingStatus || (exports.WallItemArSessionStatusCameraTrackingStatus = {}));
/**
* @export
* @enum {string}
*/
var WallItemArSessionStatusCameraTrackingPausedReason;
(function (WallItemArSessionStatusCameraTrackingPausedReason) {
    WallItemArSessionStatusCameraTrackingPausedReason["UNKNOWN"] = "CAMERA_TRACKING_PAUSED_REASON_UNKNOWN";
    WallItemArSessionStatusCameraTrackingPausedReason["INITIALIZING"] = "CAMERA_TRACKING_PAUSED_REASON_INITIALIZING";
    WallItemArSessionStatusCameraTrackingPausedReason["RELOCALIZING"] = "CAMERA_TRACKING_PAUSED_REASON_RELOCALIZING";
    WallItemArSessionStatusCameraTrackingPausedReason["EXCESSIVEMOTION"] = "CAMERA_TRACKING_PAUSED_REASON_EXCESSIVE_MOTION";
    WallItemArSessionStatusCameraTrackingPausedReason["INSUFFICIENTFEATURES"] = "CAMERA_TRACKING_PAUSED_REASON_INSUFFICIENT_FEATURES";
    WallItemArSessionStatusCameraTrackingPausedReason["INSUFFICIENTLIGHT"] = "CAMERA_TRACKING_PAUSED_REASON_INSUFFICIENT_LIGHT";
    WallItemArSessionStatusCameraTrackingPausedReason["CAMERAUNAVAILABLE"] = "CAMERA_TRACKING_PAUSED_REASON_CAMERA_UNAVAILABLE";
    WallItemArSessionStatusCameraTrackingPausedReason["BADSTATE"] = "CAMERA_TRACKING_PAUSED_REASON_BAD_STATE";
})(WallItemArSessionStatusCameraTrackingPausedReason = exports.WallItemArSessionStatusCameraTrackingPausedReason || (exports.WallItemArSessionStatusCameraTrackingPausedReason = {}));
/**
* @export
* @enum {string}
*/
var WallItemArSessionStatusWorldMappingStatus;
(function (WallItemArSessionStatusWorldMappingStatus) {
    WallItemArSessionStatusWorldMappingStatus["UNKNOWN"] = "WORLD_MAPPING_STATUS_UNKNOWN";
    WallItemArSessionStatusWorldMappingStatus["INITIALIZING"] = "WORLD_MAPPING_STATUS_INITIALIZING";
    WallItemArSessionStatusWorldMappingStatus["LIMITED"] = "WORLD_MAPPING_STATUS_LIMITED";
    WallItemArSessionStatusWorldMappingStatus["EXTENDING"] = "WORLD_MAPPING_STATUS_EXTENDING";
    WallItemArSessionStatusWorldMappingStatus["MAPPED"] = "WORLD_MAPPING_STATUS_MAPPED";
})(WallItemArSessionStatusWorldMappingStatus = exports.WallItemArSessionStatusWorldMappingStatus || (exports.WallItemArSessionStatusWorldMappingStatus = {}));
//# sourceMappingURL=WallItemArSessionStatus.js.map